import { useEffect, useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { MarketTreeMapStyle } from "./MarketTreeMap.styles";
import { percentageDaily, percentageMonthly, percentageWeekly } from "./MarketTreeMapHelpers";

export interface TreeMapLendingProps {
  timeframe: string;
}

const MarketTreeMapLegend = (props: TreeMapLendingProps) => {
  // ------------------Style Sheet---------------------------
  const classes = MarketTreeMapStyle();
  const [percentageArray, setPercentageArray] = useState<any>([]);
  const { timeframe } = props;

  useEffect(() => {
    switch (timeframe) {
      case "Monthly":
        setPercentageArray(percentageMonthly);
        break;

      case "Daily":
        setPercentageArray(percentageDaily);
        break;

      case "Weekly":
        setPercentageArray(percentageWeekly);
        break;
    }
  }, [timeframe]);

  if (timeframe) {
    return (
      <Stack
        direction="row"
        className={classes.treemapLegend}
        justifyContent="flex-end"
        alignItems="center">
        {percentageArray.map((item: any, idx: number) => {
          return (
            <Box
              key={idx}
              sx={{
                backgroundColor: item.color,
                color: "white",
                width: 100,
                height: 25,
              }}>
              <Typography sx={{ display: "flex", justifyContent: "center" }}>
                {item.amount}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    );
  }

  return <></>;
};

export default MarketTreeMapLegend;
